import { FaCheckCircle, FaExclamationCircle, FaInfoCircle } from "react-icons/fa";
import { useToastContext } from "../../context/ToastContext";
import styles from "./Toast.module.css";

const ICONS = {
  success: <FaCheckCircle />,
  error: <FaExclamationCircle />,
  info: <FaInfoCircle />,
};

function Toast() {
  const { toasts } = useToastContext();

  return (
    <div className={styles.container} aria-live="polite">
      {toasts.map(toast => (
        <div key={toast.id} className={`${styles.toast} ${styles[toast.type]}`}>
          <span className={styles.icon}>{ICONS[toast.type] || ICONS.info}</span>
          <span className={styles.message}>{toast.message}</span>
        </div>
      ))}
    </div>
  );
}

export default Toast;
